export default __webpack_public_path__ + "static/media/file-20210107-24-ll42iu.56b2a244.webp";